import { SnackbarContainer } from './SnackbarContainer'
import { SnackbarVariant } from './Snackbar'

const ERROR_MESSAGE_PATTERN = /error|no se pudo|obligatori|inv[aá]lid|vac[ií]o|fall[oó]|failed|intente|intentalo|int[eé]ntelo|no hay datos|demasiado grande|contacte|no se puede|debe |sin completar/i

const inferSnackbarVariant = (message: string): SnackbarVariant =>
  ERROR_MESSAGE_PATTERN.test(message) ? 'error' : 'success'

interface SnackbarType {
  containerInstance: SnackbarContainer | null
  show: (messsage: string, variant?: SnackbarVariant) => void
}

const snackbar: SnackbarType = {
  containerInstance: null,
  show: (message, variant) => {
    if (snackbar.containerInstance) {
      snackbar.containerInstance.showSnackbar(message, variant ?? inferSnackbarVariant(message))
    }
  },
}

export { Snackbar } from './Snackbar'
export { ErrorSnackbar } from './ErrorSnackbar'
export { SnackbarContainer, snackbar }
